export const phoneForCustomers = "8 800 200-90-02";
export const phoneAntiCorruption = "8 800 600-04-77";
export const linkSecurity = "https://magnit.ru/security/";
export const linkMyMagnit = "https://my.magnit.ru/";
export const linkHotline = "https://magnit.ru/faq/";
export const socials = {
  ok: "https://ok.ru/magnitinfo",
  vk: "https://vk.com/magnitretail",
  tg: "https://t.me/magnit_retail",
};
export const linksStores = {
  appStore: "https://redirect.appmetrica.yandex.com/serve/171509363045896356",
  ruStore: "https://redirect.appmetrica.yandex.com/serve/677311225696188231",
  googlePlay: "https://redirect.appmetrica.yandex.com/serve/243566959499742663",
  appGallery: "https://redirect.appmetrica.yandex.com/serve/892085300505886812",
  auto: "https://redirect.appmetrica.yandex.com/serve/1109053982455637484",
};
